import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Target, LifeBuoy, Gamepad2, Sparkles } from 'lucide-react';
const kitItems = [{
  label: 'Herramienta',
  title: '100 Flashcards de Palabras Frecuentes',
  desc: 'Listas para imprimir y usar desde el día 1.',
  icon: CreditCard,
  tint: 'bg-sky-50/70 border-sky-100',
  chip: 'bg-sky-100 text-sky-600',
  labelColor: 'text-sky-600'
}, {
  label: 'Práctica',
  title: '30 Misiones de Lectura Graduada',
  desc: 'Textos organizados en 3 niveles con preguntas de comprensión.',
  icon: Target,
  tint: 'bg-amber-50/70 border-amber-100',
  chip: 'bg-amber-100 text-amber-600',
  labelColor: 'text-amber-600'
}, {
  label: 'Rescate',
  title: 'Guía SOS de Rescate Emocional',
  desc: 'Scripts exactos para destrabar los 5 momentos más difíciles.',
  icon: LifeBuoy,
  tint: 'bg-rose-50/60 border-rose-100',
  chip: 'bg-rose-100 text-rose-500',
  labelColor: 'text-rose-500'
}, {
  label: 'Motivación',
  title: '4 Juegos con Flashcards',
  desc: 'Velocidad, Historia, Mímica y Memoria para practicar jugando.',
  icon: Gamepad2,
  tint: 'bg-emerald-50/60 border-emerald-100',
  chip: 'bg-emerald-100 text-emerald-600',
  labelColor: 'text-emerald-600'
}];
export function AcceleratorKit() {
  return <section className="py-12 md:py-16 bg-slate-50 text-navy" data-id="element-1">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-2">
        <div className="text-center mb-10" data-id="element-3">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 mb-4 rounded-full bg-gold/10 border border-gold/20 text-gold-600 font-bold tracking-wider uppercase text-xs" data-id="element-4">
            <Sparkles className="w-3.5 h-3.5" data-id="element-5" />
            Solo en versión Premium
          </span>
          <h2 className="text-3xl font-bold mb-4" data-id="element-6">
            EL KIT ACELERADOR DE LECTURA FLUIDA
          </h2>
          <p className="text-slate-600 max-w-xl mx-auto" data-id="element-7">
            Todo lo que necesitás para acompañar a tu hijo,{' '}
            <span className="font-semibold text-navy" data-id="element-8">
              listo para imprimir y usar desde el primer día.
            </span>
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4" data-id="element-9">
          {kitItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className={`border shadow-sm rounded-2xl p-6 ${item.tint}`} data-id="element-10">
              <div className="flex items-center gap-3 mb-3" data-id="element-11">
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${item.chip}`} data-id="element-12">
                  <item.icon className="w-5 h-5" data-id="element-13" />
                </div>
                <span className={`text-xs font-bold uppercase tracking-wider ${item.labelColor}`} data-id="element-14">
                  {item.label}
                </span>
              </div>
              <h3 className="font-bold text-lg mb-2 text-navy" data-id="element-15">{item.title}</h3>
              <p className="text-sm text-slate-500" data-id="element-16">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}